import React from 'react';
import { useDispatch } from 'react-redux';
import { logout } from '../store/session';

const SessionInvalidatedModal = ({ message, onClose }) => {
  const dispatch = useDispatch();

  const handleLogout = () => {
    console.log('Logging out from SessionInvalidatedModal');
    dispatch(logout());
    if (onClose) onClose();
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white p-6 rounded-lg shadow-lg max-w-md w-full">
        <h2 className="text-xl font-bold mb-4 text-red-600">Session Invalidated</h2>
        <p className="mb-6">
          {message || 'Your session has been invalidated because your account was logged in from another device.'}
        </p>
        <div className="flex justify-end">
          <button
            onClick={handleLogout}
            className="px-4 py-2 bg-red-500 text-white rounded hover:bg-red-600"
          >
            Log Out
          </button>
        </div>
      </div>
    </div>
  );
};

export default SessionInvalidatedModal;
